
const FaBookmark = (props:{ className : string}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={props.className ?? ""} viewBox="0 0 16 16">
      <path fillRule="evenodd" clipRule="evenodd" d="M4 2.04007V13.397L7.06296 10.8484C7.61079 10.3926 8.38921 10.3926 8.93704 10.8484L12 13.397V2.04007H4ZM3.5 1H12.5C12.7761 1 13 1.23283 13 1.52004V14.479C13 14.915 12.515 15.1575 12.1877 14.8851L8.31235 11.6606C8.12974 11.5087 7.87026 11.5087 7.68765 11.6606L3.81235 14.8851C3.48497 15.1575 3 14.915 3 14.479V1.52003C3 1.23283 3.22386 1 3.5 1Z" fill="currentColor"/>
    </svg>
 
  )
}

export default FaBookmark;